import React, { Component } from 'react';
import * as Common from '../components/Common';
import * as moment from 'moment';
import Calendar from 'react-calendar';
import '../css/calendar.css';

class CalendarPop extends Component {
  constructor(props) {
    super(props);

    this.state = {
      testUsedate: null,
      style: null
    };

  }

  componentDidMount() {
    var minDate = new Date(new Date().setDate(new Date().getDate() + 1));
    var maxDate = new Date(new Date().setDate(new Date().getDate() + 15));
    var testUsedate = this.props.testUsedate;
    this.setState({
      minDate: minDate,
      maxDate: maxDate,
      testUsedate: testUsedate ? new Date(testUsedate) : new Date(),
      style: Common.getCenterPosStyle(this.layer)
    });

    var imgPrevEle = document.createElement('img');
    imgPrevEle.className = "prev-month";
    document.getElementsByClassName('react-calendar__navigation__prev-button')[0].appendChild(imgPrevEle);

    var imgNextEle = document.createElement('img');
    imgNextEle.className = "next-month";
    document.getElementsByClassName('react-calendar__navigation__next-button')[0].appendChild(imgNextEle);
  }

  /**
   * 날짜 선택 event
   */
  _onChange = (date) => {
    this.setState({ testUsedate: date });
    var layerBgTimer = setTimeout(() => {
      this.layerBg.click();

      clearTimeout(layerBgTimer);
    }, 200);
  }

  /**
   * 날짜 disable
   */
  _tileDisabled = ({date, view}) => {
    var dateList = this.props.dateList;
    var disabled = 'disabled';
    for(var idx in dateList) {
      if(dateList[idx] === moment(date).format('YYYY-MM-DD')) {
        disabled = null;
        break;
      }
    }
    return disabled;
  }

  render() {
    return (
      <div className="layer-pop" id="date-pop" style={this.state.style} ref={ref => this.layer = ref}>	
        <div className="bg" data-testusedate={this.state.testUsedate} data-type="calendar" onClick={this.props.onClick} ref={ref => this.layerBg = ref}></div>
        <div className="date-layer-pop">
          <div className="calen-cont">
            <Calendar
              value={this.state.testUsedate}
              activeStartDate={null}
              minDetail="month"
              locale="ko-KR"
              calendarType="US"
              tileDisabled={this._tileDisabled}
              formatMonthYear={(locale, date) => moment(date).format('YYYY / MM')}
              next2Label={null}
              nextLabel={""}
              prev2Label={null}
              prevLabel={""}
              onChange={this._onChange}
            />
          </div>
        </div>
      </div>
    )
  }
}

export default CalendarPop;